__turbopack_context__.v({
  "quote-block": "hQo-Aq_quote-block",
  "quote-block--dawn": "hQo-Aq_quote-block--dawn",
  "quote-block--dawn-2": "hQo-Aq_quote-block--dawn-2",
  "quote-block--dusk": "hQo-Aq_quote-block--dusk",
  "quote-block--light-dusk": "hQo-Aq_quote-block--light-dusk",
  "quote-block--midnight": "hQo-Aq_quote-block--midnight",
  "quote-block--midnight-2": "hQo-Aq_quote-block--midnight-2",
  "quote-block--warm-red": "hQo-Aq_quote-block--warm-red",
  "quote-block__button": "hQo-Aq_quote-block__button",
  "quote-block__button--next": "hQo-Aq_quote-block__button--next",
  "quote-block__button--prev": "hQo-Aq_quote-block__button--prev",
  "quote-block__button-inner": "hQo-Aq_quote-block__button-inner",
  "quote-block__dot": "hQo-Aq_quote-block__dot",
  "quote-block__dot--active": "hQo-Aq_quote-block__dot--active",
  "quote-block__dots": "hQo-Aq_quote-block__dots",
  "quote-block__heading": "hQo-Aq_quote-block__heading",
  "quote-block__inner": "hQo-Aq_quote-block__inner",
  "quote-block__track": "hQo-Aq_quote-block__track",
  "quote-block__track-wrapper": "hQo-Aq_quote-block__track-wrapper",
  "quote-item": "hQo-Aq_quote-item",
  "quote-item__body": "hQo-Aq_quote-item__body",
  "quote-item__caption": "hQo-Aq_quote-item__caption",
});
